var acc = document.getElementsByClassName("accordio-n");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var accordionpanel = this.nextElementSibling;
    if (accordionpanel.style.maxHeight) {
      accordionpanel.style.maxHeight = null;
    } else {
      accordionpanel.style.maxHeight = accordionpanel.scrollHeight + "px";
    } 
  });
}
/////////////////////////////////////////////////
    if($(window).width() > 797) {
        $('.mobile-pp').remove();
    }
    // if($(window).width() < 797) {
    //     $('.producttitlepc').remove();
    // }
/////////////////////////////////////////////////
let tabsBtn = document.querySelectorAll(".list-item-desc");
let tabsPanel = document.querySelectorAll(".list-item-panel");
tabsBtn.forEach((item, index) => {
	item.addEventListener("click", (event) => {
		tabsBtn.forEach(tab => {
			tab.classList.remove("active");
		});
		tabsPanel.forEach(panel => {
			panel.classList.remove("active");
		});
		event.target.classList.add("active");
		tabsPanel[index].classList.add("active");
	});
});
function makeAccordian () {
  if(window.innerWidth < 768){
  tabsBtn.forEach((item, index) => {
    item.appendChild(tabsPanel[index])
  })
}
}
makeAccordian();
window.onresize = makeAccordian